<template>
  <b-card class="animated fadeIn">
    <b-row>
      <b-col>
        <VBrandLimitList
          :searchResults="searchResults"
          @edit="edit"
          @approve="approveBrandLimit"
          @deny="denyBrandLimit"
          @publish="publishBrandLimit"
          @request-approval="requestApprovalBrandLimit"
          @view-active="viewActiveBrandLimit"
          @cancel-update="cancelUpdateBrandLimit"
          :busy="isBusy"
          :isAdmin="isInRole('RTPSDataAdmin')"
          :isApprover="isInRole('RTPSDataApprover')"
          :size="20"
          :currentPage="1">
        </VBrandLimitList>
      </b-col>
    </b-row>
    <b-row v-if="isInRole('RTPSDataAdmin')">
      <b-col cols="1" sm="2" offset="10" offset-sm="10">
        <b-button variant="secondary" block @click="addBrandLimit">Add Brand Limit</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import { mapGetters, mapState } from "vuex";
  import router from "@/router";
  import {
    BRAND_LIMIT_SEARCH,
    BRAND_LIMIT_REQUESTAPPROVAL,
    BRAND_LIMIT_APPROVE,
    BRAND_LIMIT_DENY,
    BRAND_LIMIT_PUBLISH,
    BRAND_LIMIT_CANCEL
  } from "@/store/brand-limit/actions.type";
  import VBrandLimitList from "@/components/VBrandLimitList";

  export default {
    name: "BrandLimitList",
    components: {
      VBrandLimitList
    },
    data() {
      return {
        criteria: {}
      };
    },
    computed: {
      ...mapGetters({
        groups: "groups"
      }),
      ...mapState({
        searchResults: state => state.brandlimit.searchResults,
        isBusy: state => state.brandlimit.isBusy
      })
    },
    methods: {
      isInRole(role) {
        return this.groups.indexOf(role) > -1;
      },
      addBrandLimit() {
        router.push({
          name: "brand-limit-item"
        });
      },
      edit(data) {
        console.log(data);
      },
      requestApprovalBrandLimit(brandLimit) {
        if (!this.isBusy) {
          this.$store.dispatch(BRAND_LIMIT_REQUESTAPPROVAL, brandLimit);
        }
      },
      approveBrandLimit(brandLimit) {
        if (!this.isBusy) {
          this.$store.dispatch(BRAND_LIMIT_APPROVE, brandLimit);
        }
      },
      denyBrandLimit(brandLimit) {
        if (!this.isBusy) {
          this.$store.dispatch(BRAND_LIMIT_DENY, brandLimit);
        }
      },
      publishBrandLimit(brandLimit) {
        if (!this.isBusy) {
          this.$store.dispatch(BRAND_LIMIT_PUBLISH, brandLimit);
        }
      },
      cancelUpdateBrandLimit(brandLimit) {
        if (!this.isBusy) {
          this.$store.dispatch(BRAND_LIMIT_CANCEL, brandLimit);
        }
      },
      viewActiveBrandLimit(brandLimit) {
        if (!this.isBusy) {
          router.push({
            name: "brand-limit-item",
            params: {
              viewActive: true,
              brand_limit_id: brandLimit.brand_limit_id
            }
          });
        }
      }
    },
    created() {
      this.$store.dispatch(BRAND_LIMIT_SEARCH);
    }
  };
</script>

<style lang="scss">
  .source-dropdown {
    button {
      width: 140px;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/BrandLimitList.vue